// src/firebase/new-checkout-functions.js

import { DEFAULT_STORE_ID, functions } from "./firebase";
import { clearCart } from "./cart-functions";
import { httpsCallable } from "firebase/functions";

export const processCheckout = async (orderData, customerData, currentUser = null, createAccount = false) => {
    try {
        if (!orderData?.items?.length) {
            throw new Error("Order must contain at least one item");
        }

        if (!customerData?.email) {
            throw new Error("Customer email is required");
        }

        // Call simplified server function
        const processCheckoutFunction = httpsCallable(functions, 'processCheckout');
        const result = await processCheckoutFunction({
            storeId: orderData.storeId || DEFAULT_STORE_ID,
            orderData: orderData,
            customerData: customerData,
            createGuestAccount: !currentUser && createAccount
        });

        if (result.data.success) {
            // Clear cart after successful checkout
            try {
                await clearCart(currentUser);
            } catch (cartError) {
                // console.error('Error clearing cart:', cartError);
                // Don't fail checkout if cart clearing fails
            }

            // Store order confirmation
            localStorage.setItem('lastOrder', JSON.stringify({
                orderId: result.data.orderId,
                storeOrderId: result.data.storeOrderId,
                order: result.data.order,
                timestamp: new Date().toISOString()
            }));

            return {
                success: true,
                orderId: result.data.orderId,
                storeOrderId: result.data.storeOrderId,
                order: result.data.order,
                message: result.data.message
            };
        } else {
            throw new Error(result.data.message || 'Checkout failed');
        }

    } catch (error) {
        console.error('Checkout error:', error);

        // Handle specific error types
        if (error.code === 'functions/failed-precondition') {
            throw new Error('Insufficient inventory: ' + error.message);
        } else if (error.code === 'functions/invalid-argument') {
            throw new Error('Invalid order data: ' + error.message);
        } else if (error.code === 'functions/unauthenticated') {
            throw new Error('Authentication required for this operation');
        } else {
            throw new Error(error.message || 'Checkout failed. Please try again.');
        }
    }
};


export default {
    processCheckout,
};